<template>
    <div id="breadcrumb">
        <div class="ui divider"></div>
        <div class="ui breadcrumb">
            <i class="icon refresh pointer" @click="refresh()" style="cursor: pointer;"></i>
            <!-- 目前位置： -->
            {{ $t('ui.page_titles.current_page') }}：
            <router-link :to="{name: 'customer_index'}" class="section">
                {{ $t('ui.page_titles.index') }}
            </router-link>

            <span v-for="(breadcrumb, index) in $store.state.breadcrumbs">
                <i class="right chevron icon divider" v-if="breadcrumb"></i>
                <span v-if="index == $store.state.breadcrumbs.length - 1">
                    <div class="section">
                        {{ $t('ui.page_titles.' + breadcrumb) }}
                    </div>
                </span>
                <span v-else>
                    <router-link
                        :to="{name: breadcrumb}"
                        class="active section">
                        {{ $t('ui.page_titles.' + breadcrumb) }}
                    </router-link>
                </span>
            </span>
        </div>
        <div class="ui divider"></div>
    </div>
</template>

<script>
export default {
    computed: {
    },
    methods: {
        refresh() {
            console.log('customer refresh')
            if (this.$bus['_events']['init']) {
                this.$bus.$emit('init')
            } else {
                location.reload()
            }
        },
    },
}
</script>
